module.exports = __webpack_public_path__ + "img/cordoba_winter.ad3ef66a.svg";